import React from 'react'
import { Box, Typography } from '@mui/material'
import AddIconButton from '../../../../components/ui/button/AddIconButton'
import { ROUTES } from '../../../../helpers/routes-helper'
import { useNavigate } from 'react-router'

const LeaderboardHeader: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py={{ xs: 3, md: 5 }}
    >
      <Typography variant="h3">Points</Typography>

      <AddIconButton variant="outlined" onClick={() => navigate(ROUTES.REFER_AND_EARN)}>
        Invite Others
      </AddIconButton>
    </Box>
  )
}

export default LeaderboardHeader
